import { format } from "date-fns";

import type { RomFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/rom/types/rom-form";
import type { RomFlowsheetFormSchemaType } from "@/encounters/components/EncounterLabor/flowsheet-forms/rom/zod-schemas/rom-flowsheet-form";
import { localToUtcTimeString } from "@/utils/timeUtils";

/** Empty form values with null datetime. Used when hydrating from a QuestionnaireResponse. */
export function getEmptyRomFlowsheetFormValues(): RomFlowsheetFormValues {
  return {
    examDate: null,
    examTime: null,
    method: null,
    confirmedBy: null,
    confirmedByOther: "",
    fluidColor: null,
    fluidColorOther: "",
    notes: "",
    signatureInitials: [],
  };
}

/** Defaults for a new quick-add form, with the current local date and time filled in. */
export function getDefaultRomFlowsheetFormValues(): RomFlowsheetFormValues {
  const now = new Date();
  const localTime = format(now, "HH:mm:ss");
  return {
    ...getEmptyRomFlowsheetFormValues(),
    examDate: now,
    examTime: localToUtcTimeString(localTime),
  };
}

export function normalizeRomFlowsheetFormValues(
  parsed: RomFlowsheetFormSchemaType,
): RomFlowsheetFormValues {
  // Keep explicit null date/time from the form. Current date/time only comes from
  // getDefaultRomFlowsheetFormValues for new quick-add entries.
  const empty = getEmptyRomFlowsheetFormValues();
  return {
    examDate: parsed.examDate !== undefined ? parsed.examDate : empty.examDate,
    examTime: parsed.examTime !== undefined ? parsed.examTime : empty.examTime,
    method: parsed.method ?? empty.method,
    confirmedBy: parsed.confirmedBy ?? empty.confirmedBy,
    confirmedByOther: parsed.confirmedByOther ?? empty.confirmedByOther,
    fluidColor: parsed.fluidColor ?? empty.fluidColor,
    fluidColorOther: parsed.fluidColorOther ?? empty.fluidColorOther,
    notes: parsed.notes ?? empty.notes,
    signatureInitials: parsed.signatureInitials ?? empty.signatureInitials,
  };
}
